import api from "./api";

export const AccessControlAPI = {
  listJobs: () => api("/access-control/jobs"),

  listUsers: ({ systemId, schoolId, search } = {}) => {
    const params = new URLSearchParams();

    if (systemId) params.set("systemId", systemId);
    if (schoolId) params.set("schoolId", schoolId);
    if (search) params.set("search", search);

    const query = params.toString();
    return api(`/access-control/users${query ? `?${query}` : ""}`);
  },

  getUser: (id) => api(`/access-control/users/${id}`),

  listUserTokens: (id) => api(`/access-control/users/${id}/tokens`),

  listDoors: ({ systemId, schoolId } = {}) => {
    const params = new URLSearchParams();

    if (systemId) params.set("systemId", systemId);
    if (schoolId) params.set("schoolId", schoolId);

    const query = params.toString();
    return api(`/access-control/doors${query ? `?${query}` : ""}`);
  },


  listAccessLevels: (systemId) => api(`/access-control/access-levels/${systemId}`),

  test: (payload) =>
    api("/access-control/test", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  linkUser: ({ id, nightjarUserId, email }) =>
    api(`/access-control/users/${id}/link`, {
      method: "POST",
      body: JSON.stringify({ nightjarUserId, email }),
    }),

  createJob: (payload) =>
    api("/access-control/jobs", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  runAction: ({ systemId, schoolId, action, payload }) =>
    api("/access-control/jobs", {
      method: "POST",
      body: JSON.stringify({ systemId, schoolId, action, payload }),
    }),

  // Convenience wrappers
  getAllUsers: (systemId, schoolId) =>
    api("/access-control/jobs", {
      method: "POST",
      body: JSON.stringify({ systemId, schoolId, action: "GetAllUsers" }),
    }),

  getDoorStatus: (systemId, schoolId) =>
    api("/access-control/jobs", {
      method: "POST",
      body: JSON.stringify({ systemId, schoolId, action: "GetDoorStatus" }),
    }),

  addToken: ({ systemId, schoolId, email, tokenNumber, tokenType }) =>
    api("/access-control/jobs", {
      method: "POST",
      body: JSON.stringify({
        systemId,
        schoolId,
        action: "AddToken",
        payload: {
          EmailAddress: email,
          TokenNumber: tokenNumber,
          TokenType: tokenType || "fob",
        },
      }),
    }),

  // User-scoped token actions (used from user detail page)
  addUserToken: ({ id, tokenNumber, tokenType }) =>
    api(`/access-control/users/${id}/tokens`, {
      method: "POST",
      body: JSON.stringify({ tokenNumber, tokenType }),
    }),

  removeUserToken: ({ id, tokenNumber }) =>
    api(`/access-control/users/${id}/tokens`, {
      method: "DELETE",
      body: JSON.stringify({ tokenNumber }),
    }),

  // User access levels
  getUserAccess: (id) => api(`/access-control/users/${id}/access`),

  setUserAccess: ({ id, systemId, accessLevelId }) =>
    api(`/access-control/users/${id}/access`, {
      method: "POST",
      body: JSON.stringify({ systemId, accessLevelId }),
    }),
};

export const AccessSystemsAPI = {
  list: () => api("/access-control/systems"),

  test: (payload) =>
    api("/access-control/test", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  create: (payload) =>
    api("/access-control/systems", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  update: (id, payload) =>
    api(`/access-control/systems/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  toggle: (id, enabled) =>
    api(`/access-control/systems/${id}/enabled`, {
      method: "PATCH",
      body: JSON.stringify({ enabled }),
    }),
};